/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const StarFilledIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Star Filled',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M11.49541,2.41401l1.20352,3.18317c.21146.55928.73487.93956,1.33211.96784l3.39952.16098c1.49264.07068,2.10363,1.95114.9376,2.88567l-2.6558,2.12853c-.46708.37435-.66689.99056-.50834,1.56776l.8957,3.26096c.3964,1.44316-1.20676,2.60738-2.45643,1.78386l-2.81918-1.85781c-.49979-.32936-1.14755-.33006-1.64806-.00178l-2.86668,1.88025c-1.24918.81934-2.84794-.34282-2.45403-1.78386l.89758-3.2836c.15766-.57675-.04227-1.19206-.50883-1.56599l-2.65557-2.12834c-1.16603-.93453-.55503-2.81498.9376-2.88567l3.39945-.16098c.59724-.02828,1.12065-.40856,1.33211-.96782l1.20357-3.1832c.52848-1.39773,2.50569-1.39772,3.03416.00001Z"
      fill="currentColor"
    />
  </svg>`;
};
